module.exports = __webpack_public_path__ + "img/rightSide.df4508f.jpg";